import { render, staticRenderFns } from "./gamesplayed-pergame.vue?vue&type=template&id=d174f73e&"
import script from "./gamesplayed-pergame.vue?vue&type=script&lang=js&"
export * from "./gamesplayed-pergame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports